import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { CftTank, CftButton } from "../../index";

export const ONBOARDING_COOKIE = "sadda3fwsdfasAdsA";

function Step3({ handleClose, setStep, updateStyle }) {
  const { t } = useTranslation(["cftChickenBroiler"]);

  useEffect(() => {
    const dev = document.querySelector(".cft-clear-form");

    window.scrollTo({
      top: dev.getBoundingClientRect().top + window.pageYOffset,
      behavior: "smooth",
    });
    setTimeout(() => {
      const dev = document.querySelector(".cft-clear-form");
      const box = dev.getBoundingClientRect();
      const style = {
        width: "100vw",
        height: box.height,
        top: box.top + 16,
        left: 0,
        opacity: 1,
      };
      updateStyle(style);
    }, 800);
  }, []);

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: "15vw",
        }}
      >
        <h3 className="cft-onboarding__item__title">
          {t("cftChickenBroiler:onboarding:step3.title", "Wyczyść formularz")}
        </h3>
        <p className="cft-onboarding__item__subtitle">
          {t(
            "cftChickenBroiler:onboarding:step3.subtitle",
            "Jeżeli chcesz zacząć wypełniać sekcję od początku w każdym momencie możesz wyczyścić formularz klikając w przycisk “Wyczyść formularz”. "
          )}
        </p>
        <CftTank justifyContent="center" alignItems="center">
          <CftButton
            variant="transparent"
            onClick={handleClose}
            style={{ marginTop: "1rem" }}
          >
            {t("cft:onboarding.skip", "Pomiń")}
          </CftButton>
          <CftButton
            variant="active"
            onClick={() => setStep(step => step + 1)}
            style={{ marginTop: "1rem" }}
          >
            {t("cft:onboarding.next", "Dalej")}
          </CftButton>
        </CftTank>
      </div>
    </>
  );
}

export default Step3;
